import { render } from "./KanoBranch.vue?vue&type=template&id=5b50f7fa&scoped=true"
import script from "./KanoBranch.vue?vue&type=script&lang=js"
export * from "./KanoBranch.vue?vue&type=script&lang=js"

import "./KanoBranch.vue?vue&type=style&index=0&id=5b50f7fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b50f7fa"]])

export default __exports__